import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity('post_msgs')

export class PostMsgsEntity {  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("int",{
    nullable:false,
    name:"post_id"
  })
  postId:number;
  @Column("int",{
    nullable:true,
    name:"user_id"
  })
  userId:number;
  @Column("varchar",{
    nullable:true,
    name:"user_type"
  })
  userType:string;

  @Column("int",{
    nullable:true,
    name:"sent"
  })
  sent:number;

  @Column("int",{
    nullable:true,
    name:"remains"
  })
  remains:number;

  @Column("int",{
    nullable:true,
    name:"lcount"
  })
  lcount:number;

  @Column("date",{
    name:"ins_dt"
  })
  insDate:string;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  
  
}
